import { render, staticRenderFns } from "./FileApplyTable.vue?vue&type=template&id=cb068270&scoped=true&"
import script from "./FileApplyTable.vue?vue&type=script&lang=ts&"
export * from "./FileApplyTable.vue?vue&type=script&lang=ts&"
import style0 from "./FileApplyTable.vue?vue&type=style&index=0&id=cb068270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb068270",
  null
  
)

export default component.exports